const MS_PER_DAY = 24 * 60 * 60 * 1000;

// A date entered without a time (expiration, réception, OS…) is stored at UTC
// midnight: read in local time, it falls on the day before west of Greenwich.
// It keeps its UTC day; any other value is an instant, shown on the local day.
const dayTimeZone = (date: Date) =>
  date.getTime() % MS_PER_DAY === 0 ? "UTC" : undefined;

/** Format a day as jj/mm/aaaa. */
export function formatDay(value: Date | string): string {
  const date = new Date(value);
  return date.toLocaleDateString("fr-FR", { timeZone: dayTimeZone(date) });
}

/** Today on the local calendar, as a `type="date"` value (YYYY-MM-DD). */
export function todayLocal(): string {
  return new Date().toLocaleDateString("en-CA");
}

/** The local time, as a `type="time"` value (HH:MM). */
export function nowLocalTime(): string {
  return new Date().toTimeString().slice(0, 5);
}

/**
 * Format a single date for display (e.g., "15 janvier 2024")
 */
export function formatDate(date: Date | string | null): string {
  if (!date) {
    return "Non définie";
  }

  const d = new Date(date);
  return new Intl.DateTimeFormat("fr-FR", {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: dayTimeZone(d),
  }).format(d);
}

/**
 * Combine a `type="date"` value and a `type="time"` value into an ISO
 * timestamp. Used for the maquette version "date d'état", entered as
 * two separate native inputs rather than a single `datetime-local` field.
 * Returns `null` if either part is empty or the result isn't a valid date.
 */
export function combineDateAndTime(date: string, time: string): string | null {
  if (!date || !time) return null;
  const combined = new Date(`${date}T${time}`);
  if (Number.isNaN(combined.getTime())) return null;
  return combined.toISOString();
}
